import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiDocumentVerificationCompleteData,
  type EnrollmentMultiDocumentVerificationCompleteSubmitOutput,
} from '../../../../models'

export const getEnrollmentMultiDocumentVerificationCompleteDataMock: EnrollmentMultiDocumentVerificationCompleteData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/document-verification-complete',
}

export const submitEnrollmentMultiDocumentVerificationCompleteDataMock: EnrollmentMultiDocumentVerificationCompleteSubmitOutput =
  {
    __typename: 'SubmitEnrollmentSuccess',
    path: '/enrollment/multi/welcome',
  }

export const mockGetEnrollmentMultiDocumentVerificationCompleteData = graphql.mutation(
  'getEnrollmentMultiDocumentVerificationCompleteData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiDocumentVerificationCompleteDataMock } })
  },
)

export const mockSubmitEnrollmentMultiDocumentVerificationCompleteData = graphql.mutation(
  'submitEnrollmentMultiDocumentVerificationCompleteData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiDocumentVerificationCompleteDataMock } })
  },
)

export const mockEnrollmentMultiDocumentVerificationComplete = [
  mockGetEnrollmentMultiDocumentVerificationCompleteData,
  mockSubmitEnrollmentMultiDocumentVerificationCompleteData,
]
